import MainContent from "./Components/Foreground/MainContent";

export default function App() {
    return (
        <MainContent />
    )
}
